<template>
  <div>
    <form @submit.prevent="createUser">
      <label>
        カード番号 1010 8521 1723
        <input v-model="cardNum" type="number" />から
      </label>
      <label>
        連番で
        <input v-model="num" type="number" />個
      </label>
      <button v-bind:disabled="disabled">作成</button>
    </form>
    <div class="info" v-if="info">{{ info }}</div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: "UserAdmin",
  data() {
    return {
      cardNum: 0,
      num: 0,
      info: false,
      disabled: false,
      created: 0,
      infomation: null,
    };
  },
  methods: {
    createUser: function() {
      var self = this;
      self.disabled = true;
      self.infomation = setInterval(() => this.userInfo(), 3000);
      for (var i = 0; i < self.num; i++) {
        var card4 = Number(self.cardNum) + i;
        console.log(card4);
        var card = "101085211723" + card4;
        console.log(card);
        var pass = Math.floor(Math.abs(Math.cos(card4)) * 1000);
        var param = { username: card, password: pass };
        self.$axios
          .post(self.$store.state.APIbase + "/records/users", param)
          .then(res => {
            console.log(res);
            self.created++;
            self.info = 'ユーザーを' + self.created + '人作成しました';
          }).catch(function (error) {
            self.info = 'ユーザーの作成に失敗しました';
            console.log(error);
            self.disabled = false;
          });
      }
    },
    userInfo: function(){
      if(this.created == this.num){
        clearInterval(this.infomation);
        this.info = false;
        this.disabled = false;
        this.created = 0;
      }else{
        console.log(this.created + '/' +this.num);
      }
    }
  }
};
</script>

<style scoped>
form {
  margin-top: 2rem;
}
.info{
  color: #bae8e8;
  font-weight: bold;
}
</style>